import script from "./InfoSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSheet.vue?vue&type=script&setup=true&lang=js"

import "./InfoSheet.vue?vue&type=style&index=0&id=2e761485&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e761485"]])

export default __exports__